import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CopilotLauncherProps {
  onClick: () => void;
  isOpen: boolean;
}

export function CopilotLauncher({ onClick, isOpen }: CopilotLauncherProps): React.ReactElement {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      className="gap-2 bg-transparent border-purple-500/60 hover:bg-accent/50 transition-all duration-300"
      aria-label="Open Copilot panel"
    >
      <Sparkles className="h-4 w-4" />
      <span className="hidden sm:inline">Ask Copilot</span>
    </Button>
  );
}
